import { render, staticRenderFns } from "./SentimentModelList.vue?vue&type=template&id=60d5c21b&"
import script from "./SentimentModelList.vue?vue&type=script&lang=js&"
export * from "./SentimentModelList.vue?vue&type=script&lang=js&"
import style0 from "./SentimentModelList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports